import React, { useState, useRef } from "react";
import { useNavigate, Link } from 'react-router-dom';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import {Row,Col, Button} from 'react-bootstrap/';

import { Eye, EyeSlash } from 'react-bootstrap-icons';

import AuthService from "../services/auth.service";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Campo requerido!
      </div>
    );
  }
};

const Login = () => {
  let navigate = useNavigate();

  const form = useRef();
  const checkBtn = useRef();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleLogin = (e) => {
    e.preventDefault();

    setMessage("");
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(username, password).then(
        () => {
          navigate("/profile");
          window.location.reload();
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
            setLoading(false);
            setMessage(resMessage);
            if(error.response.data.message==="Invalid Password!"){
              setMessage("Contraseña Incorrecta");
              setLoading(false);
            }
            if(error.response.data.message==="User Not found."){
              setMessage("Usuario no encontrado");
              setLoading(false);
            }
          
        }
      );
    } else {
      setLoading(false);
    }
  };

  return (
    
    <div className="col-md-12">
      <div className="card card-container" style = {{borderColor: "orange", backgroundColor : "white"}}>
        <img
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        />

        <Form onSubmit={handleLogin} ref={form}>
          <div className="form-group">
            <label htmlFor="username">Usuario</label>
            <Input
              type="text"
              className="form-control"
              name="username"
              value={username}
              onChange={onChangeUsername}
              validations={[required]}
            />
            
          </div>

        
          <div className="form-group ">
            
          <label htmlFor="password">Contraseña</label>
          <Input
                type={passwordShown ? "text" : "password"}
                className="form-control"
                name="password"
                value={password}
                onChange={onChangePassword}
                validations={[required]}
              />
          <p onClick={togglePasswordVisiblity} style={{paddingTop: '10px'}}>Mostar Contraseña<i style={{paddingLeft : '10px'}}>
            {
              passwordShown ? <EyeSlash  size={30}/> : <Eye  size={30}/>
            }
            </i>
          </p>
          </div>

          <div className="form-group">
            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Login</span>
            </button>
           
           
          </div>
          <div className="form-group">
            <Link to={"/register"} > 
                <button className="btn btn-warning btn-block" disabled={loading}>
                {loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span>Quiero ser Cliente</span>
              </button>
            </Link>
            
          </div>
     
          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          <Row className="d-flex justify-content-center">
            <Link to={`/forgotpassword`} activeClassName="active" className="justify-content-md-center">
              <Button variant="outline-dark">Olvidé mi contraseña</Button>
            </Link>
          </Row>
          <CheckButton style={{ display: "none" }} ref={checkBtn} />
        </Form>
      </div>
    </div>
  );
};

export default Login;
